import type { ClientWithPending } from '@/types'

/**
 * The clients list in two parts, after the search: clients with a crawl run,
 * most recent first, then the ones never crawled, alphabetically.
 *
 * "Crawled" means any run exists: `lastCrawlAt` is the latest run's start,
 * finished or not.
 */
export function partitionClients(clients: ClientWithPending[], query: string) {
  const needle = query.trim().toLowerCase()
  const matching = clients.filter(
    (c) => !needle || c.name.toLowerCase().includes(needle) || c.primaryDomain?.toLowerCase().includes(needle),
  )
  return {
    crawled: matching
      .filter((c) => c.lastCrawlAt !== null)
      .sort((a, b) => b.lastCrawlAt!.localeCompare(a.lastCrawlAt!)),
    notCrawled: matching
      .filter((c) => c.lastCrawlAt === null)
      .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })),
  }
}
